<template>
    <div class="flex flex-col w-full px-5 gap-3">
        <div class="flex items-center gap-2">
            <hsc-menu-style-white>
                <hsc-menu-button-menu>
                    <app-button icon="icon-filter" size="mini" :label="$t('commons.state')">
                        <icon-chevron-down width="16px" heigth="16px" />
                    </app-button>
                    <template slot="contextmenu">
                        <hsc-menu-item
                            v-model="allChecked"
                            :disabled="allChecked"
                            :label="$t('commons.all')"
                            @input="selectAllState"
                        />
                        <hsc-menu-item
                            v-model="pendingValidationChecked"
                            :label="$t('transactions.states.pendingValidation')"
                            @input="updateState"
                        />
                        <hsc-menu-item
                            v-model="pendingPaymentChecked"
                            :label="$t('transactions.states.pendingPayment')"
                            @input="updateState"
                        />
                        <hsc-menu-item
                            v-model="payedChecked"
                            :label="$t('transactions.states.payedPlural')"
                            @input="updateState"
                        />
                        <hsc-menu-item
                            v-model="expiredChecked"
                            :label="$t('transactions.states.expiredPlural')"
                            @input="updateState"
                        />
                        <hsc-menu-item
                            v-model="noneChecked"
                            :label="$t('commons.none')"
                            @input="selectNoneState"
                            :disabled="noneChecked"
                        />
                    </template>
                </hsc-menu-button-menu>
            </hsc-menu-style-white>
            <app-filter class="flex-grow" ref="filter" v-model="filterAsString" @input="updateState"></app-filter>
            <div class="flex gap-2 justify-center items-end">
                <div class="flex gap-2 justify-center my-2">
                    <app-button size="mini" icon="icon-chevron-left" @click="previousRange()"></app-button>
                    <div class="text-sm md:flex-col gap-2 md:gap-0 flex flex-row">
                        <div class="flex items-center">
                            <app-date-link
                                :label="$t('commons.from')"
                                v-model="startDate"
                                @input="updateState"
                            ></app-date-link>
                        </div>
                        <div class="flex items-center">
                            <app-date-link
                                :label="$t('commons.to')"
                                v-model="endDate"
                                @input="updateState"
                            ></app-date-link>
                        </div>
                    </div>
                    <app-button size="mini" icon="icon-chevron-right" @click="nextRange()"></app-button>
                </div>
            </div>
        </div>
        <div class="flex justify-start w-full">
            <app-button
                size="mini"
                icon="icon-file-download-outline"
                @click="downloadCSV()"
                :title="$t('organizations.downloadCSV')"
            />
        </div>
        <table class="text-xs border">
            <thead>
                <th class="p-1 border text-left" style="width: 5em">
                    <button
                        v-if="sortBy === 'createdAt'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('order.licensesOrder.quoteDate') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'createdAt'">
                        {{ $t('order.licensesOrder.quoteDate') }}
                    </button>
                </th>
                <th class="p-1 border text-left" style="width: 5em">
                    <button
                        v-if="sortBy === 'billingDate'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('order.licensesOrder.billingDate') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'billingDate'">
                        {{ $t('order.licensesOrder.billingDate') }}
                    </button>
                </th>
                <th class="p-1 border text-left" style="width: 6em">
                    <button
                        v-if="sortBy === 'reference'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('order.project.orders.reference') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'reference'">
                        {{ $t('order.project.orders.reference') }}
                    </button>
                </th>
                <th class="p-1 border text-left" style="width: 10em">
                    <button
                        v-if="sortBy === 'code'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('commons.code') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'code'">
                        {{ $t('commons.code') }}
                    </button>
                </th>
                <th class="p-1 border text-left" style="">
                    <button
                        v-if="sortBy === 'name'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('commons.name') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'name'">
                        {{ $t('commons.name') }}
                    </button>
                </th>
                <th class="p-1 border text-left" style="">
                    <button
                        v-if="sortBy === 'city'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('commons.city') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'city'">
                        {{ $t('commons.city') }}
                    </button>
                </th>
                <th class="p-1 border text-left" style="">
                    <button
                        v-if="sortBy === 'organizationName'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('transactions.organizationName') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button
                        v-else
                        class="hover:underline flex justify-center w-full"
                        @click="sortBy = 'organizationName'"
                    >
                        {{ $t('transactions.organizationName') }}
                    </button>
                </th>
                <th class="p-1 border text-right" style="width: 10em">{{ $t('organizations.billings.amountHT') }}</th>
                <th class="p-1 border text-right" style="width: 10em">{{ $t('organizations.billings.amountTTC') }}</th>
                <th class="p-1 border text-left" style="">
                    <button
                        v-if="sortBy === 'expireAt'"
                        class="hover:underline flex justify-center w-full"
                        @click="sortAsc = !sortAsc"
                    >
                        {{ $t('contracts.expireAt') }}
                        <icon-menu-up v-if="sortAsc" width="16" height="16" />
                        <icon-menu-down v-else width="16" height="16" />
                    </button>
                    <button v-else class="hover:underline flex justify-center w-full" @click="sortBy = 'expireAt'">
                        {{ $t('contracts.expireAt') }}
                    </button>
                </th>
                <th class="p-1 border text-center" style="width: 15em">
                    {{ $t('commons.state') }}
                </th>
                <th class="p-1 border" style="width: 4em">
                    <div class="flex justify-center">
                        <icon-rotate-right v-if="prepareZip" class="animate animate-spin"></icon-rotate-right>
                        <app-button
                            variant="borderless"
                            size="mini"
                            v-else
                            icon="icon-download"
                            class="text-xs"
                            @click="downloadAll"
                            :title="$t('organizations.downloadPDF')"
                        ></app-button>
                    </div>
                </th>
            </thead>

            <tr v-for="transaction in filteredTransactions">
                <td class="p-1 border">{{ transaction.createdAt | humanizeDate }}</td>
                <td class="p-1 border">{{ transaction.billingDate | humanizeDate }}</td>
                <td class="p-1 border text-center">
                    {{ transaction.reference }}
                </td>
                <td class="p-1 border text-center">
                    {{ transaction.project.code }}
                </td>
                <td class="p-1 border">
                    <router-link
                        :to="{ name: 'project', params: { projectId: transaction.project.id } }"
                        class="hover:underline"
                    >
                        {{ transaction.project.name }}
                    </router-link>
                </td>
                <td class="p-1 border">
                    {{ transaction.project.city }}
                </td>
                <td class="p-1 border">
                    {{ transaction.organization?.name || transaction.billingName }}
                </td>
                <td class="p-1 border text-right">
                    {{ $n(transaction.totalHT, currency) }}
                </td>
                <td class="p-1 border text-right">
                    {{ $n(transaction.totalHT + transaction.totalHT * 0.2, currency) }}
                </td>
                <td class="p-1 border">
                    <app-date-link
                        v-model="transaction.expireAt"
                        :show-label="false"
                        :class="transaction.expireAt.getTime() < Date.now() ? 'text-red-600 font-bold' : ''"
                        v-if="!transaction.validatedOn"
                        @input="saveExpireAt(transaction)"
                    ></app-date-link>
                </td>
                <td class="p-1 border">
                    <div class="flex justify-center">
                        <span v-if="transaction.validationPending">
                            <icon-rotate-right class="animate animate-spin"></icon-rotate-right>
                        </span>
                        <span v-else-if="transaction.payedOn" class="text-green-600">
                            {{ $t('transactions.states.payed') }}
                        </span>
                        <span
                            v-else-if="!transaction.validatedOn && transaction.expireAt.getTime() < Date.now()"
                            class="text-red-600"
                        >
                            {{ $t('transactions.states.expired') }}
                        </span>
                        <span
                            :title="transaction.validatedOn | humanizeDate"
                            v-else-if="!transaction.validatedOn && transaction.expireAt.getTime() >= Date.now()"
                        >
                            {{ $t('transactions.states.pendingValidation') }}
                        </span>
                        <span v-else-if="transaction.validatedOn" class="text-yellow-600">
                            {{ $t('transactions.states.pendingPayment') }}
                        </span>
                    </div>
                </td>
                <td class="p-1 border">
                    <div class="flex gap-1 justify-center">
                        <app-file-link
                            class="text-xs"
                            icon="icon-file-outline"
                            :file-name="transaction.quoteFileName"
                            :class="{
                                'text-yellow-500':
                                    transaction.quoteFileName &&
                                    !transaction.validatedOn &&
                                    transaction.expireAt.getTime() >= Date.now(),
                                'text-green-600': transaction.validatedOn,
                                'text-red-600 font-bold':
                                    transaction.quoteFileName &&
                                    !transaction.validatedOn &&
                                    transaction.expireAt.getTime() < Date.now(),
                            }"
                            :url="transaction.quoteUrl"
                            :show-name="false"
                            text="D"
                            :title="$t('organizations.downloadFile') + ' ' + transaction.quoteFileName"
                        ></app-file-link>
                        <app-file-link
                            icon="icon-file-outline"
                            class="text-xs"
                            :class="{ 'opacity-25': !transaction.proformaUrl }"
                            :file-name="transaction.proformaFileName"
                            :url="transaction.proformaUrl"
                            :show-name="false"
                            :title="$t('organizations.downloadFile') + ' ' + transaction.proformaFileName"
                            text="P"
                        ></app-file-link>
                        <app-file-link
                            class="text-xs"
                            icon="icon-file-outline"
                            :class="{
                                'opacity-25': !transaction.billUrl,
                                'text-yellow-500':
                                    transaction.billUrl && transaction.validatedOn && !transaction.payedOn,
                                'text-green-600': transaction.payedOn,
                            }"
                            :disabled="!transaction.billUrl"
                            :file-name="transaction.invoiceFileName"
                            :url="transaction.billUrl"
                            :show-name="false"
                            text="F"
                            :title="$t('organizations.downloadFile') + ' ' + transaction.invoiceFileName"
                        ></app-file-link>
                    </div>
                </td>
                <td class="p-1 border">
                    <div class="flex gap-1 justify-center">
                        <app-button
                            size="mini"
                            icon="icon-check"
                            label="D"
                            :title="$t('transactions.validateQuote')"
                            @click="validateQuote(transaction)"
                            v-if="!transaction.validatedOn"
                        />
                        <app-button
                            size="mini"
                            icon="icon-undo"
                            label=""
                            :title="$t('transactions.cancelValidateQuote')"
                            @click="cancelValidateQuote(transaction)"
                            v-if="!transaction.billUrl && transaction.validatedOn"
                        />
                        <app-button
                            size="mini"
                            icon="icon-check"
                            label="F"
                            :title="$t('transactions.generateInvoice')"
                            @click="generateInvoice(transaction)"
                            v-if="!transaction.billUrl && transaction.validatedOn"
                        />
                        <app-button
                            size="mini"
                            icon="icon-check"
                            label="€"
                            :title="$t('transactions.validatePayment')"
                            @click="validatePayment(transaction)"
                            v-if="transaction.validatedOn && !transaction.payedOn"
                        />
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import AppInputText from '@/components/appInputText/AppInputText.vue';
import AppPhone from '@/components/appPhone/AppPhone.vue';
import AppPhoneInput from '@/components/appPhoneInput/AppPhoneInput.vue';
import AppMail from '@/components/appMail/AppMail.vue';
import AppButton from '@/components/appButton/AppButton.vue';
import AppPopup from '@/components/app-popup/AppPopup.vue';
import AppFooter from '@/components/appFooter/AppFooter.vue';
import IconFileDownloadOutline from '@/icons/IconFileDownloadOutline.vue';
import AppFileLink from '@/components/appFileLink/AppFileLink.vue';
import AppFilter from '@/components/appFilter/AppFilter.vue';
import { filterMatch } from '@/services/sanitize.service';
import { humanizeDate, humanizeDateShort } from '@/filters/dateFilter';
import AppDateInput from '@/components/appDateInput/AppDateInput.vue';
import AppDateLink from '@/components/appDateLink/AppDateLink.vue';
import { startOfDay, addYears, endOfDay, subYears } from 'date-fns';
import { sortBy } from '@/services/sanitize.service';
import isValid from 'date-fns/isValid';
import endOfYear from 'date-fns/endOfYear';
import startOfYear from 'date-fns/startOfYear';
import { getAPIHeaders } from '@/services/api.service';
import IconCheckCircleOutline from '@/icons/IconCheckCircleOutline.vue';
import IconChevronDown from '@/icons/IconChevronDown.vue';
import IconTimerAlertOutline from '@/icons/IconTimerAlertOutline.vue';
import IconRotateRight from '@/icons/IconRotateRight.vue';
import { getTransactions } from '@/features/transactions/transactions.service';
import { error } from '@/features/toasts/toats.service';

export default {
    components: {
        IconRotateRight,
        IconTimerAlertOutline,
        IconChevronDown,
        IconCheckCircleOutline,
        AppDateLink,
        AppDateInput,
        AppFilter,
        AppFileLink,
        IconFileDownloadOutline,
        AppFooter,
        AppPhoneInput,
        AppInputText,
        AppPopup,
        AppMail,
        AppPhone,
        AppButton,
    },
    created() {
        this.init();
    },
    watch: {
        $route() {
            this.init();
        },
    },
    computed: {
        minDate() {
            return startOfDay(this.startDate);
        },
        maxDate() {
            return endOfDay(this.endDate);
        },
        filteredTransactions() {
            const list = sortBy(
                this.transactions.filter((item) => {
                    return (
                        this.datesMatch(item.billingDate || item.createdAt, this.minDate, this.maxDate) &&
                        (!this.filterAsString || filterMatch(item.filterString, this.filterAsString, true)) &&
                        ((this.pendingValidationChecked &&
                            !item.validatedOn &&
                            item.expireAt.getTime() >= Date.now()) ||
                            (this.pendingPaymentChecked && !!item.validatedOn && !item.payedOn) ||
                            (this.payedChecked && !!item.payedOn) ||
                            (this.expiredChecked && !item.validatedOn && item.expireAt.getTime() < Date.now()))
                    );
                }),
                (item) => {
                    if (this.sortBy === 'name') {
                        return item.project.name;
                    } else if (this.sortBy === 'code') {
                        return item.project.code;
                    } else if (this.sortBy === 'city') {
                        return item.project.city;
                    } else if (this.sortBy === 'organizationName') {
                        return item.organization?.name || item.billingName || '';
                    } else if (this.sortBy === 'expireAt') {
                        return item.expireAt.getTime();
                    } else if (this.sortBy === 'quoteDate') {
                        return item.createdAt?.getTime() || 0;
                    } else if (this.sortBy === 'billingDate') {
                        return item.billingDate?.getTime();
                    } else {
                        return item[this.sortBy];
                    }
                },
            );
            if (!this.sortAsc) {
                list.reverse();
            }
            return list;
        },
    },
    methods: {
        async validateQuote(item) {
            item.validationPending = true;
            const response = await fetch(
                new Request(`/api/projects/${item.project.id}/licensesOrders/${item.id}`, {
                    method: 'PUT',
                    headers: getAPIHeaders({ 'content-type': `application/json` }),
                    body: JSON.stringify({ id: item.id, validatedOn: new Date() }),
                }),
            );
            if (!response.ok) {
                error(await response.text());
            }
            this.init();
        },
        async cancelValidateQuote(item) {
            item.validationPending = true;
            await fetch(
                new Request(`/api/projects/${item.project.id}/licensesOrders/${item.id}`, {
                    method: 'PUT',
                    headers: getAPIHeaders({ 'content-type': `application/json` }),
                    body: JSON.stringify({ id: item.id, validatedOn: null }),
                }),
            );
            this.init();
        },
        async saveExpireAt(item) {
            await fetch(
                new Request(`/api/projects/${item.project.id}/licensesOrders/${item.id}`, {
                    method: 'PUT',
                    headers: getAPIHeaders({ 'content-type': `application/json` }),
                    body: JSON.stringify({ id: item.id, expireAt: item.expireAt.toISOString() }),
                }),
            );
            this.init();
        },
        async validatePayment(item) {
            item.validationPending = true;
            await fetch(
                new Request(`/api/transactions/${item.id}`, {
                    method: 'PUT',
                    headers: getAPIHeaders({ 'content-type': `application/json` }),
                    body: JSON.stringify({ id: item.id, payedOn: new Date() }),
                }),
            );
            this.init();
        },
        async generateInvoice(item) {
            item.validationPending = true;
            await fetch(
                new Request(`/api/projects/${item.project.id}/licensesOrders/${item.id}`, {
                    method: 'PUT',
                    headers: getAPIHeaders({ 'content-type': `application/json` }),
                    body: JSON.stringify({ id: item.id, billingDate: new Date() }),
                }),
            );
            this.init();
        },
        downloadCSV: function () {
            const header =
                '"Date Devis";"Date Facture";"Référence";"Code Opération";"Nom Opération";"Ville Opération";"Nom Organisation";"Expiration";"Montant HC";"Montant TTC";"Statut";"Devis PDF";"Proforma PDF";"Facture PDF"\n';
            const urlPrefix = 'https://app.tex.moe/';
            this.downloadAsCSVFile(
                header +
                    this.filteredTransactions
                        .map((transaction) =>
                            [
                                humanizeDate(transaction.createdAt) || '',
                                transaction.billingDate ? humanizeDate(transaction.billingDate) : '',
                                transaction.reference || '',
                                transaction.project.code || '',
                                transaction.project.name || '',
                                transaction.project.city || '',
                                (transaction.organization?.name
                                    ? transaction.organization.name
                                    : transaction.billingName) || '',
                                humanizeDate(transaction.expireAt) || '',
                                this.$n(transaction.totalHT, this.currency),
                                this.$n(transaction.totalHT + transaction.totalHT * 0.2, this.currency),
                                transaction.validationPending
                                    ? ''
                                    : transaction.payedOn
                                    ? this.$t('transactions.states.payed')
                                    : !transaction.validatedOn && transaction.expireAt.getTime() < Date.now()
                                    ? this.$t('transactions.states.expired')
                                    : !transaction.validatedOn && transaction.expireAt.getTime() >= Date.now()
                                    ? this.$t('transactions.states.pendingValidation')
                                    : transaction.validatedOn || transaction.billUrl
                                    ? this.$t('transactions.states.pendingPayment')
                                    : '',
                                transaction.quoteUrl ? urlPrefix + transaction.quoteUrl : '',
                                transaction.proformaUrl ? urlPrefix + transaction.proformaUrl : '',
                                transaction.billUrl ? urlPrefix + transaction.billUrl : '',
                            ]
                                .map((entry) => '"' + entry.replaceAll('"', '') + '"')
                                .join(';'),
                        )
                        .join('\n'),
            );
        },
        datesMatch: function (date, min, max) {
            return date && (!isValid(min) || min.getTime() < date.getTime()) && (!isValid(max) || date.getTime() < max);
        },
        nextRange() {
            if (isValid(this.startDate)) {
                this.startDate = addYears(this.minDate, 1);
            }
            if (isValid(this.endDate)) {
                this.endDate = addYears(this.maxDate, 1);
            }
            this.updateState();
        },
        previousRange() {
            if (isValid(this.startDate)) {
                this.startDate = subYears(this.minDate, 1);
            }
            if (isValid(this.endDate)) {
                this.endDate = subYears(this.maxDate, 1);
            }
            this.updateState();
        },
        updateState() {
            this.allChecked =
                this.pendingValidationChecked && this.expiredChecked && this.pendingPaymentChecked && this.payedChecked;
            this.noneChecked =
                !this.pendingValidationChecked &&
                !this.expiredChecked &&
                !this.pendingPaymentChecked &&
                !this.payedChecked;
            localStorage.setItem(
                'transactions.filters',
                JSON.stringify({
                    filterAsString: this.filterAsString,
                    startDate: isValid(this.startDate) ? startOfDay(this.startDate) : null,
                    endDate: isValid(this.endDate) ? endOfDay(this.endDate) : null,
                    expiredChecked: this.expiredChecked,
                    pendingValidationChecked: this.pendingValidationChecked,
                    pendingPaymentChecked: this.pendingPaymentChecked,
                    payedChecked: this.payedChecked,
                }),
            );
        },
        selectAllState() {
            this.expiredChecked = true;
            this.pendingValidationChecked = true;
            this.pendingPaymentChecked = true;
            this.payedChecked = true;
            this.updateState();
        },
        selectNoneState() {
            this.expiredChecked = false;
            this.pendingValidationChecked = false;
            this.pendingPaymentChecked = false;
            this.payedChecked = false;
            this.updateState();
        },
        async init() {
            this.transactions = (await getTransactions()).map((item) => ({
                ...item,
                proformaFileName: this.$t('order.project.orders.proforma') + '_' + item.reference + '.pdf',
                quoteFileName: this.$t('order.project.orders.quote') + '_' + item.reference + '.pdf',
                invoiceFileName: this.$t('order.project.orders.bill') + '_' + item.reference + '.pdf',
                validationPending: false,
                date: new Date(
                    item.payedOn
                        ? item.payedOn
                        : item.validatedOn
                        ? item.validatedOn
                        : item.expireAt.getTime() < Date.now()
                        ? item.expireAt
                        : item.createdAt,
                ),
                filterString:
                    humanizeDate(item.createdAt) +
                    '_' +
                    humanizeDate(item.billingDate) +
                    '_' +
                    item.project.name +
                    '_' +
                    item.project.code +
                    '_' +
                    item.organization?.name +
                    '_' +
                    item.reference +
                    '_' +
                    item.project.city +
                    '_' +
                    this.$n(item.totalHT, this.currency) +
                    '_' +
                    this.$n(item.totalHT + item.totalHT * 0.2, this.currency),
            }));

            const state = localStorage.getItem('transactions.filters')
                ? JSON.parse(localStorage.getItem('transactions.filters'))
                : null;
            if (state) {
                this.filterAsString = state.filterAsString;
                this.startDate = new Date(state.startDate || startOfYear(new Date()));
                this.endDate = new Date(state.endDate || endOfYear(new Date()));
                this.expiredChecked = state.expiredChecked !== false;
                this.pendingValidationChecked = state.pendingValidationChecked !== false;
                this.pendingPaymentChecked = state.pendingPaymentChecked !== false;
                this.payedChecked = state.payedChecked !== false;
                this.allChecked =
                    this.pendingValidationChecked &&
                    this.expiredChecked &&
                    this.pendingPaymentChecked &&
                    this.payedChecked;
                this.noneChecked =
                    !this.pendingValidationChecked &&
                    !this.expiredChecked &&
                    !this.pendingPaymentChecked &&
                    !this.payedChecked;
            } else {
                this.filterAsString = '';
                if (this.transactions.length > 0) {
                    this.startDate = new Date(
                        this.transactions.reduce(
                            (acc, { date }) => (acc && acc < date.getTime() ? acc : date.getTime()),
                            0,
                        ),
                    );
                    this.endDate = new Date(
                        this.transactions.reduce(
                            (acc, { date }) => (acc && acc > date.getTime() ? acc : date.getTime()),
                            0,
                        ),
                    );
                } else {
                    this.startDate = startOfYear(new Date());
                    this.endDate = endOfYear(new Date());
                }
                this.endDate = new Date(
                    this.transactions.reduce(
                        (acc, { date }) => (acc && acc > date.getTime() ? acc : date.getTime()),
                        0,
                    ),
                );
            }
        },
        async downloadAll() {
            this.prepareZip = true;
            const response = await fetch(
                new Request(`/api/transactions/AsZip`, {
                    method: 'POST',
                    headers: getAPIHeaders({ 'content-type': `application/json` }),
                    body: JSON.stringify(this.filteredTransactions.map((item) => item.id)),
                }),
            );
            await this.downloadAsZipFile(response);
            this.prepareZip = false;
        },
        async downloadAsZipFile(response) {
            const a = document.createElement('a');
            const fileContents = await response.blob();
            const url = URL.createObjectURL(fileContents);
            a.setAttribute('href', url);
            a.download = `transactionsTex_${this.startDate ? humanizeDateShort(this.startDate) : ''}_${
                this.endDate ? humanizeDateShort(this.endDate) : ''
            }.zip`;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function () {
                URL.revokeObjectURL(a.href);
            }, 1500);
        },
        async downloadAsCSVFile(content) {
            const a = document.createElement('a');
            a.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(content));
            a.download = `facturesTex_${this.startDate ? humanizeDateShort(this.startDate) : ''}_${
                this.endDate ? humanizeDateShort(this.endDate) : ''
            }.csv`;
            a.dataset.downloadurl = ['text/csv', a.download, a.href].join(':');
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function () {
                URL.revokeObjectURL(a.href);
            }, 1500);
        },
    },
    data() {
        return {
            filterAsString: '',
            transactions: [],
            currency: {
                currency: 'EUR',
                style: 'currency',
            },
            startDate: null,
            endDate: null,
            sortBy: 'date',
            sortAsc: true,
            prepareZip: false,

            allChecked: true,
            noneChecked: false,
            expiredChecked: true,
            pendingValidationChecked: true,
            pendingPaymentChecked: true,
            payedChecked: true,
        };
    },
};
</script>
